(function () {
  'use strict';

  var LS_KEY = 'tw_invoice_form_data';

  var ATTR = {
    type: 'invoice_type',
    carrierType: 'invoice_carrier_type',
    carrierNum: 'invoice_carrier_num',
    taxId: 'invoice_tax_id',
    companyTitle: 'invoice_company_title',
    loveCode: 'invoice_love_code',
    donate: 'invoice_donate',
  };

  var _cartSaveTimer = null;

  // ── 驗證函式 ────────────────────────────────────────────────

  function validateMobileBarcode(val) {
    // / 開頭共 8 碼，後 7 碼為大寫英數及 +-.
    return /^\/[A-Z0-9+\-.]{7}$/.test(val);
  }

  function validateNaturalPersonCert(val) {
    // 2 碼大寫英文 + 14 碼數字
    return /^[A-Z]{2}[0-9]{14}$/.test(val);
  }

  function validateTaxId(val) {
    if (!/^\d{8}$/.test(val)) return false;
    var weights = [1, 2, 1, 2, 1, 2, 4, 1];
    var sum = 0;
    for (var i = 0; i < 8; i++) {
      var product = parseInt(val[i], 10) * weights[i];
      sum += Math.floor(product / 10) + (product % 10);
    }
    // 財政部 2023 起新統編改為 % 5（舊統編 % 10 === 0 隱含 % 5 === 0，向下相容）
    if (sum % 5 === 0) return true;
    // 第 7 碼為 7 時的特殊情形
    if (val[6] === '7' && (sum - 1) % 5 === 0) return true;
    return false;
  }

  function validateLoveCode(val) {
    return /^[0-9]{3,7}$/.test(val);
  }

  // ── DOM 工具 ────────────────────────────────────────────────

  function el(id) {
    return document.getElementById(id);
  }

  function setError(errorId, msg) {
    var node = el(errorId);
    if (!node) return;
    if (msg) {
      node.textContent = msg;
      node.style.display = 'block';
    } else {
      node.textContent = '';
      node.style.display = 'none';
    }
  }

  function setBorder(inputId, valid) {
    var node = el(inputId);
    if (node) node.style.borderColor = valid ? '#ccc' : '#e53e3e';
  }

  // ── 表單狀態讀取 ────────────────────────────────────────────

  function getChecked(name) {
    var node = document.querySelector('input[name="' + name + '"]:checked');
    return node ? node.value : null;
  }

  function getFormData() {
    var data = {};
    data.type = getChecked('invoice_type') || 'personal';

    if (data.type === 'personal') {
      data.carrierType = getChecked('invoice_carrier_type') || 'none';
      if (data.carrierType !== 'none') {
        var carrierInput = el('inv-carrier-num');
        data.carrierNum = carrierInput ? carrierInput.value.trim().toUpperCase() : '';
      } else {
        data.carrierNum = '';
      }
    } else if (data.type === 'company') {
      var taxInput = el('inv-tax-id');
      var titleInput = el('inv-company-title');
      data.taxId = taxInput ? taxInput.value.trim() : '';
      data.companyTitle = titleInput ? titleInput.value.trim() : '';
    } else if (data.type === 'donate') {
      var loveInput = el('inv-love-code');
      data.loveCode = loveInput ? loveInput.value.trim() : '';
    }

    return data;
  }

  // ── Cart Attributes 對應 ────────────────────────────────────

  function buildAttributes(data) {
    var attrs = {};
    attrs[ATTR.type] = data.type || 'personal';
    attrs[ATTR.donate] = data.type === 'donate' ? 'true' : 'false';
    attrs[ATTR.carrierType] = data.type === 'personal' ? (data.carrierType || 'none') : '';
    attrs[ATTR.carrierNum] = (data.type === 'personal' && data.carrierType !== 'none') ? (data.carrierNum || '') : '';
    attrs[ATTR.taxId] = data.type === 'company' ? (data.taxId || '') : '';
    attrs[ATTR.companyTitle] = data.type === 'company' ? (data.companyTitle || '') : '';
    attrs[ATTR.loveCode] = data.type === 'donate' ? (data.loveCode || '') : '';
    return attrs;
  }

  function saveToCart(data) {
    var attributes = buildAttributes(data);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Oribrif-Gift-Skip': 'true',
      },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function (err) {
      console.error('[invoice-form] 無法更新 cart attributes:', err);
    });
  }

  // ── sessionStorage ──────────────────────────────────────────

  function saveToLS(data) {
    try { sessionStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function loadFromLS() {
    try {
      var raw = sessionStorage.getItem(LS_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  // ── UI 顯示切換 ──────────────────────────────────────────────

  function showSection(type) {
    ['personal', 'company', 'donate'].forEach(function (t) {
      var section = el('inv-section-' + t);
      if (section) section.style.display = t === type ? 'block' : 'none';
    });
  }

  function showCarrierInput(carrierType) {
    var wrapper = el('inv-carrier-input-wrapper');
    var label = el('inv-carrier-label');
    var input = el('inv-carrier-num');
    if (!wrapper) return;

    if (input) input.value = '';
    if (carrierType === 'mobile_barcode') {
      wrapper.style.display = 'block';
      if (label) label.textContent = '手機條碼';
      if (input) {
        input.placeholder = '/ABC+123';
        input.maxLength = 8;
        input.style.textTransform = 'uppercase';
      }
    } else if (carrierType === 'natural_person_cert') {
      wrapper.style.display = 'block';
      if (label) label.textContent = '自然人憑證號碼';
      if (input) {
        input.placeholder = 'AB12345678901234';
        input.maxLength = 16;
        input.style.textTransform = 'uppercase';
      }
    } else {
      wrapper.style.display = 'none';
    }
  }

  // ── 結帳前完整驗證 ───────────────────────────────────────────

  function validateAll() {
    var data = getFormData();
    var valid = true;

    if (data.type === 'personal') {
      // 清除非個人錯誤
      setError('inv-tax-id-error', '');
      setError('inv-company-title-error', '');
      setError('inv-love-code-error', '');
      setBorder('inv-tax-id', true);
      setBorder('inv-company-title', true);
      setBorder('inv-love-code', true);

      if (data.carrierType === 'mobile_barcode') {
        var mok = validateMobileBarcode(data.carrierNum);
        setError('inv-carrier-error', mok ? '' : '手機條碼格式錯誤（/ 開頭共 8 碼，後 7 碼為大寫英數及 +-.)');
        setBorder('inv-carrier-num', mok);
        if (!mok) valid = false;
      } else if (data.carrierType === 'natural_person_cert') {
        var cok = validateNaturalPersonCert(data.carrierNum);
        setError('inv-carrier-error', cok ? '' : '自然人憑證格式錯誤（2 碼大寫英文 + 14 碼數字）');
        setBorder('inv-carrier-num', cok);
        if (!cok) valid = false;
      } else {
        setError('inv-carrier-error', '');
        setBorder('inv-carrier-num', true);
      }
    } else if (data.type === 'company') {
      setError('inv-carrier-error', '');
      setError('inv-love-code-error', '');
      setBorder('inv-carrier-num', true);
      setBorder('inv-love-code', true);

      var tok = validateTaxId(data.taxId);
      setError('inv-tax-id-error', tok ? '' : '統一編號格式錯誤（8 碼數字，需通過 MOD11 驗證）');
      setBorder('inv-tax-id', tok);
      if (!tok) valid = false;

      var titleOk = data.companyTitle.length > 0;
      setError('inv-company-title-error', titleOk ? '' : '請填寫公司抬頭');
      setBorder('inv-company-title', titleOk);
      if (!titleOk) valid = false;
    } else if (data.type === 'donate') {
      setError('inv-carrier-error', '');
      setError('inv-tax-id-error', '');
      setError('inv-company-title-error', '');
      setBorder('inv-carrier-num', true);
      setBorder('inv-tax-id', true);
      setBorder('inv-company-title', true);

      var lok = validateLoveCode(data.loveCode);
      setError('inv-love-code-error', lok ? '' : '請選擇捐贈對象');
      setBorder('inv-love-code', lok);
      if (!lok) valid = false;
    }

    return valid;
  }

  // ── 欄位變更處理 ─────────────────────────────────────────────

  function onFormChange() {
    var data = getFormData();
    saveToLS(data);
    // debounce cart save：避免逐字觸發多個 AJAX 競態，導致 Shopify
    // 最後收到的是中間態（例如只剩 "/"）而非完整值
    clearTimeout(_cartSaveTimer);
    _cartSaveTimer = setTimeout(function () {
      saveToCart(getFormData());
    }, 400);
  }

  // ── 還原上次資料 ─────────────────────────────────────────────

  function restoreFromData(data) {
    if (!data || !data.type) return;

    var typeRadio = el('inv-type-' + data.type);
    if (typeRadio) typeRadio.checked = true;
    showSection(data.type);

    if (data.type === 'personal') {
      var carrierIdMap = { none: 'inv-carrier-none', mobile_barcode: 'inv-carrier-mobile', natural_person_cert: 'inv-carrier-cert' };
      var carrierRadio = el(carrierIdMap[data.carrierType] || 'inv-carrier-none');
      if (carrierRadio) carrierRadio.checked = true;
      showCarrierInput(data.carrierType || 'none');
      if (data.carrierNum) {
        var carrierInput = el('inv-carrier-num');
        if (carrierInput) carrierInput.value = data.carrierNum;
      }
    } else if (data.type === 'company') {
      if (data.taxId) { var t = el('inv-tax-id'); if (t) t.value = data.taxId; }
      if (data.companyTitle) { var c = el('inv-company-title'); if (c) c.value = data.companyTitle; }
    } else if (data.type === 'donate') {
      if (data.loveCode) { var l = el('inv-love-code'); if (l) l.value = data.loveCode; }
    }
  }

  // ── 初始化 ──────────────────────────────────────────────────

  function init() {
    var wrapper = el('invoice-form-wrapper');
    if (!wrapper) return;
    if (wrapper.dataset.invoiceInited) return;
    wrapper.dataset.invoiceInited = '1';

    // 預設值：個人發票 + 無載具
    var defaultType = el('inv-type-personal');
    if (defaultType && !getChecked('invoice_type')) defaultType.checked = true;

    var defaultCarrier = el('inv-carrier-none');
    if (defaultCarrier && !getChecked('invoice_carrier_type')) defaultCarrier.checked = true;

    // 從 localStorage 還原，否則套用預設
    var saved = loadFromLS();
    if (saved) {
      restoreFromData(saved);
      onFormChange(); // 還原後同步寫入新的 cart attributes（連續購買時舊 cart 已清空）
    } else {
      showSection('personal');
      showCarrierInput('none');
      onFormChange(); // 將預設值寫入 cart attributes
    }

    // 發票類型切換
    document.querySelectorAll('input[name="invoice_type"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        showSection(this.value);
        onFormChange();
      });
    });

    // 載具類型切換
    document.querySelectorAll('input[name="invoice_carrier_type"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        showCarrierInput(this.value);
        setError('inv-carrier-error', '');
        setBorder('inv-carrier-num', true);
        onFormChange();
      });
    });

    // 文字欄位 input 事件
    ['inv-carrier-num', 'inv-tax-id', 'inv-company-title', 'inv-love-code'].forEach(function (id) {
      var node = el(id);
      if (node) node.addEventListener('input', onFormChange);
    });

    // 結帳按鈕攔截
    var checkoutBtn = el('cart-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        if (!validateAll()) {
          e.preventDefault();
          e.stopPropagation();
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        // 清除 debounce，確保最新發票資料在結帳前寫入 cart attributes
        e.preventDefault();
        clearTimeout(_cartSaveTimer);
        var attrs = buildAttributes(getFormData());
        var giftThreshold = window.OribrifGiftThreshold;
        var releaseCheckout =
          giftThreshold && typeof giftThreshold.lockCheckout === 'function'
            ? giftThreshold.lockCheckout()
            : function () {};

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Oribrif-Gift-Skip': 'true',
          },
          body: JSON.stringify({ attributes: attrs }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to update cart attributes');
            return response.json();
          })
          .then(function (cartSnapshot) {
            var waitForGiftSync = giftThreshold && giftThreshold.whenStable;
            return typeof waitForGiftSync === 'function' ? waitForGiftSync(cartSnapshot) : true;
          })
          .then(function (isReady) {
            if (isReady) window.location = '/checkout';
          })
          .catch(function (error) {
            console.error('[invoice-form] 結帳前購物車同步失敗:', error);
            var cartErrors = el('cart-errors');
            if (cartErrors) {
              cartErrors.setAttribute('role', 'alert');
              cartErrors.textContent = '購物車更新失敗，請稍後再試。';
            }
          })
          .finally(releaseCheckout);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
